import React from "react";
import DashboardWrapper from "./dashboardWrapper";
import TextField from "../../components/textField/textField";
import BiographyEdit from "../../pageparts/biographyEdit";

export default function DashboardProfilePage() {

    return  <BiographyEdit/>;
    
}